import httpClient from 'js/httpClient';

export function normaliseDatasetMap(datasets) {
    if (!datasets) {
        return {};
    }

    if (!Array.isArray(datasets)) {
        return datasets;
    }

    return datasets.reduce((map, dataset) => {
        if (dataset?.uuid) {
            map[dataset.uuid] = dataset;
        }
        return map;
    }, {});
}

export function mergeDatasetGroupVersions(datasetGroup, fetchedDatasets = {}) {
    if (!datasetGroup?.uuid) {
        return null;
    }

    const existingDatasets = normaliseDatasetMap(datasetGroup.datasets);
    const fetchedDatasetMap = normaliseDatasetMap(fetchedDatasets);

    return {
        ...datasetGroup,
        datasets: {
            ...fetchedDatasetMap,
            ...existingDatasets,
        },
    };
}

export async function hydrateDatasetGroupVersions(
    datasetGroup,
    {
        pathname = window.location.pathname,
        fetchDatasets = httpClient.get.bind(httpClient),
    } = {}
) {
    if (!datasetGroup?.uuid) {
        return datasetGroup;
    }

    if (pathname !== '/view') {
        return mergeDatasetGroupVersions(datasetGroup);
    }

    try {
        let response = await fetchDatasets('/api/v1/datasets/', {
            params: {
                dataset_group__uuid: datasetGroup.uuid,
                size: 100,
            },
        });
        const fetchedDatasets = [...(response.data?.results || [])];

        while (response.data?.next) {
            response = await fetchDatasets(response.data.next);
            fetchedDatasets.push(...(response.data?.results || []));
        }

        return mergeDatasetGroupVersions(
            datasetGroup,
            fetchedDatasets
        );
    } catch (error) {
        if (error?.response?.status !== 401) {
            // eslint-disable-next-line no-console
            console.error(error);
        }

        return mergeDatasetGroupVersions(datasetGroup);
    }
}
